import { AbstractCommand } from '../AbstractCommand';

import type { KaraokeConfig } from '@src/editor/models/karaoke/KaraokeConfig';
import type { VideoEditor } from '@src/editor/VideoEditor';

export class UpdateKaraokeConfigCommand extends AbstractCommand {
  getName(): string {
    return 'UpdateKaraokeConfigCommand';
  }

  private oldKaraokeConfig: KaraokeConfig | null = null;
  private karaokeConfig: KaraokeConfig;

  constructor(editor: VideoEditor, karaokeConfig: KaraokeConfig) {
    super(editor);
    this.karaokeConfig = karaokeConfig;
  }

  execute(): boolean {
    const currentConfig = this.editor
      .getKaraokeConfigsMap()
      .get(this.karaokeConfig.id);
    if (!currentConfig) {
      console.error('Cannot update karaoke config: Config not found');
      return false;
    }

    this.oldKaraokeConfig = { ...currentConfig };
    this.editor.updateKaraokeConfig(this.karaokeConfig);
    this.editor.getKaraokeTrack()?.karaokeClips.forEach(clip => {
      if (clip.karaokeConfig.id === this.karaokeConfig.id) {
        clip.setKaraokeConfig(this.karaokeConfig);
      }
    });

    // Mark editor as dirty
    this.editor.markDirty('karaoke_config_updated');

    return true;
  }

  undo(): boolean {
    if (!this.oldKaraokeConfig) {
      console.error(
        'Cannot undo update karaoke config: No previous config stored',
      );
      return false;
    }
    this.editor.updateKaraokeConfig(this.oldKaraokeConfig);
    // Mark editor as dirty
    this.editor.markDirty('karaoke_config_updated');
    return true;
  }

  getDescription(): string {
    return 'Update karaoke configuration';
  }
}
